import { el, setChildren } from 'redom';

import application from 'application';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import SingleSelectInputBox from 'generics/components/single-select/native/input-box';

import './index.scss';

class MemberSelector {

  constructor(configuration) {

    this.memberId = configuration.memberId;
    this.onChange = configuration.onChange;

    this.el = el('.member-selector-main', [
      el('ht-spinner')
    ]);

  }

  handleMemberChange({ values }) {

    this.onChange(values[0]);

  }

  getSelectedMemberIndices(members) {

    const index = findIndexByPropertyValue(members, '_id', this.memberId);

    if (index === -1) {
      return [];
    }

    return [index];

  }

  buildMemberInputOptions(members) {

    const options = {
      placeholder: 'Select a member',
      options: members,
      labelFieldName: 'fullName',
      valueFieldName: '_id',
      selectedOptionIndices: this.getSelectedMemberIndices(members),
      onChange: this.handleMemberChange.bind(this)
    };

    return options;

  }

  displayMemberInput(members) {

    setChildren(this.el, [new SingleSelectInputBox(this.buildMemberInputOptions(members))]);

  }

  async initialize() {

    const _members = await application.startupModule.members.loadMembers();

    const members = _members.filter(function openForAppointmentMembersFilter(member) {
      return member.openForMeetings === true;
    });

    this.displayMemberInput(members);

  }

  onmount() {

    this.initialize();

  }

}

export default MemberSelector;